import * as actionTypes from '../actions/actionTypes';
import updateState,{addIngredient, removeIngredient} from '../../utility';


const initialState = {
    totalPrice: 4,
    ingredients: null,
    ingredientsError: false,
    building: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.ITEM_HANDLER:

            switch (action.value) {
                case '+': return addIngredient(state, action)
                case '-': return removeIngredient(state, action)
                default:
            }
            break;

        case actionTypes.SET_INGREDIENTS:
            return updateState(state, { ingredients: action.ingredients, totalPrice: 4, building: false })
        case actionTypes.NO_INGREDIENTS:
            return updateState(state, { ingredientsError: true })
        default:
            return state
    }

}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducer/BurgerBuilder.js